import { Ranks } from '@/types'

export const ranks: Ranks = [
  {
    division: 'no rank',
    badge: 'no_rank.png',
    minAmount: 0,
  },
  {
    division: 'bronze',
    tier: 1,
    minAmount: 10000, // Stake's Bronze entry point
    badge: 'cooper_1.png',
  },
  {
    division: 'bronze',
    tier: 2,
    minAmount: 20000,
    badge: 'cooper_2.png',
  },
  {
    division: 'bronze',
    tier: 3,
    minAmount: 30000,
    badge: 'cooper_3.png',
  },
  {
    division: 'bronze',
    tier: 4,
    minAmount: 40000,
    badge: 'cooper_4.png',
  },
  {
    division: 'bronze',
    tier: 5,
    minAmount: 50000,
    badge: 'cooper_5.png',
  },
  {
    division: 'silver',
    tier: 1,
    minAmount: 50000, // Stake's Silver entry point
    badge: 'silver_1.png',
  },
  {
    division: 'silver',
    tier: 2,
    minAmount: 75000,
    badge: 'silver_2.png',
  },
  {
    division: 'silver',
    tier: 3,
    minAmount: 100000,
    badge: 'silver_3.png',
  },
  {
    division: 'silver',
    tier: 4,
    minAmount: 125000,
    badge: 'silver_4.png',
  },
  {
    division: 'silver',
    tier: 5,
    minAmount: 150000,
    badge: 'silver_5.png',
  },
  {
    division: 'gold',
    tier: 1,
    minAmount: 100000, // Stake's Gold entry point
    badge: 'gold_1.png',
  },
  {
    division: 'gold',
    tier: 2,
    minAmount: 150000,
    badge: 'gold_2.png',
  },
  {
    division: 'gold',
    tier: 3,
    minAmount: 200000,
    badge: 'gold_3.png',
  },
  {
    division: 'gold',
    tier: 4,
    minAmount: 250000,
    badge: 'gold_4.png',
  },
  {
    division: 'gold',
    tier: 5,
    minAmount: 300000,
    badge: 'gold_5.png',
  },
  {
    division: 'platinum',
    tier: 1,
    minAmount: 250000, // Stake's Platinum I
    badge: 'platinum_1.png',
  },
  {
    division: 'platinum',
    tier: 2,
    minAmount: 500000, // Platinum II
    badge: 'platinum_2.png',
  },
  {
    division: 'platinum',
    tier: 3,
    minAmount: 1000000, // Platinum III
    badge: 'platinum_3.png',
  },
  {
    division: 'platinum',
    tier: 4,
    minAmount: 2500000, // Platinum IV
    badge: 'platinum_4.png',
  },
  {
    division: 'platinum',
    tier: 5,
    minAmount: 5000000, // Platinum V
    badge: 'platinum_5.png',
  },
  {
    division: 'diamond',
    tier: 1,
    minAmount: 25000000, // Stake's Diamond entry point
    badge: 'diamond_1.png',
  },
  {
    division: 'diamond',
    tier: 2,
    minAmount: 50000000,
    badge: 'diamond_2.png',
  },
  {
    division: 'diamond',
    tier: 3,
    minAmount: 75000000,
    badge: 'diamond_3.png',
  },
  {
    division: 'diamond',
    tier: 4,
    minAmount: 100000000,
    badge: 'diamond_4.png',
  },
  {
    division: 'diamond',
    tier: 5,
    minAmount: 1500000000,
    badge: 'diamond_5.png',
  },
]